<template>
  <el-dialog title="选择主要数据" :visible.sync="isShow" :close-on-click-modal="false" :modal="false" width="500px">
    <el-radio-group v-model="radio">
      <el-radio v-for="item in radishes" :key="item._id" class="radio-box" :label="item._id">
        <p class="radio-span-box">
          <span class="dialog-span drawer-link" @click="showRadish(item)">{{ item.姓名 }}</span>
          <span class="dialog-span" style="color:#aaa">{{ item.手机 }}</span>
          <span class="dialog-span">{{ item.公司 }}</span> <span class="dialog-span">{{ item.部门 }}</span>
          <span class="dialog-span">{{ item.目前职位 }}</span> <span class="dialog-span">{{ item.职级 }}</span>
          <span class="dialog-span"
            ><el-tag v-for="tag in item.职能模块" :key="tag" size="mini">{{ tag }}</el-tag></span
          >
        </p>
      </el-radio>
    </el-radio-group>
    <span slot="footer" class="dialog-footer">
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="isShow = false">取 消</div>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="confirmMerge">确 定</div>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      isShow: false,
      radishes: [],
      radio: '',
    }
  },
  methods: {
    open(radishes) {
      this.isShow = true
      this.radishes = radishes
    },
    showRadish(radish) {
      window.open(`${window.frontend}/#/radish-detail-blank/${radish._id}`, '_blank')
    },
    async confirmMerge() {
      if (this.radio === '') return this.$message('请选择以哪条数据为主')
      const first = this.radio
      const second = this.radishes.map(v => v._id).filter(v => v !== first)

      const res = await app.service('radish').mergeMult({ id: first, first, second })
      if (res.status === 'success') {
        const radish = this.radishes.filter(v => v._id === first)
        this.$emit('choose')
        this.isShow = false
      } else this.$message(res.msg)
    },
  },
}
</script>
<style scoped>
.radio-box {
  margin: 0 0 4px 4px;
  display: flex;
}
.radio-span-box {
  display: flex;
  flex-wrap: wrap;
}
.radio-span-box .dialog-span {
  margin-right: 4px;
}
</style>
